// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://gseaqfjhwzlabkemtlwy.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImdzZWFxZmpod3psYWJrZW10bHd5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTgwMTAyNTMsImV4cCI6MjA3MzU4NjI1M30.RfmHih4-Cz5jDSF7wOX0YRx3mYFQ5keyWaJIrlUbjH4";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
    // Explicitly declare PKCE — required for Google OAuth to correctly store
    // and retrieve the code verifier across the redirect boundary.
    flowType: 'pkce',
  }
});